var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    overflow: "visible",
    enableBackground: "new 0 0 144 144",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Premise"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Premise_1_",
    fill: "#0077c0",
    d: "M70.866,2.268C31.728,2.268,0,33.996,0,73.134C0,112.272,31.728,144,70.866,144 c39.138,0,70.866-31.728,70.866-70.866C141.732,33.996,110.004,2.268,70.866,2.268z M111.603,76.842 c-3.198,1.886-55.453,32.101-59.237,34.199c-2.771,1.539-6.406-0.161-6.406-3.663v-68.38c0-3.179,3.289-5.544,6.539-3.685 c2.605,1.489,54.662,31.55,59.104,34.122C114.521,71.125,114.472,75.151,111.603,76.842z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremise);
export default __webpack_public_path__ + "static/media/premise.c9e0bc61.svg";
export { ForwardRef as ReactComponent };